import { createAction } from 'redux-actions'
import * as globalTypes from '../../actions/types'
import AuthService from './service'
import history from '../../history'


export const sendResetPasswordEmail = email => (
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
    AuthService
      .sendResetPasswordEmail(email)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        history.push('/login')
        return dispatch(createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Email enviado, verifique a sua caixa de entrada.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }))
      })
      .catch((err) => {
        console.log(err)
      })
  }
)

export default sendResetPasswordEmail
